import styled from 'styled-components';
import { colors } from 'styles/colors';

export const ModalOverlay = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${colors.neutral[900]}50;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: white;
  width: 439px;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 80%;
    margin: 0 24px;
    overflow: hidden;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 150%;
  margin-bottom: 16px;

  & > div {
    display: flex;
    gap: 8px;
  }

  h3 {
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    color: ${colors.text['main-900']};
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  align-self: flex-start;
  display: flex;
  padding: 6px;
`;

export const ModalContent = styled.div`
  display: flex;

  @media (max-width: 768px) {
    overflow-y: auto;
  }
`;
